module.exports = __webpack_public_path__ + "static/media/vehicleregistrationfront.bd2b6046.jpg";